import * as React from "react";
const SvgTimeIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10.5123 5.84039C10.5123 3.25988 8.42035 1.16797 5.83984 1.16797", stroke: "#A3A3A3", style: {
  stroke: "#A3A3A3",
  stroke: "color(display-p3 0.6375 0.6375 0.6375)",
  strokeOpacity: 1
}, strokeDasharray: "1.56 3.11" }), /* @__PURE__ */ React.createElement("path", { d: "M10.5123 5.83984C10.5123 8.42035 8.42035 10.5123 5.83984 10.5123", stroke: "#A3A3A3", style: {
  stroke: "#A3A3A3",
  stroke: "color(display-p3 0.6375 0.6375 0.6375)",
  strokeOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M5.84039 10.5128C3.25988 10.5128 1.16797 8.4209 1.16797 5.84039C1.16797 3.25988 3.25988 1.16797 5.84039 1.16797", stroke: "#A3A3A3", style: {
  stroke: "#A3A3A3",
  stroke: "color(display-p3 0.6375 0.6375 0.6375)",
  strokeOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M6.61067 5.84049C6.61067 6.26585 6.26585 6.61067 5.84049 6.61067C5.41513 6.61067 5.07031 6.26585 5.07031 5.84049C5.07031 5.41513 5.41513 5.07031 5.84049 5.07031C6.26585 5.07031 6.61067 5.41513 6.61067 5.84049Z", fill: "#A3A3A3", style: {
  fill: "#A3A3A3",
  fill: "color(display-p3 0.6375 0.6375 0.6375)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M5.83984 5.84011L7.592 3.50391", stroke: "#A3A3A3", style: {
  stroke: "#A3A3A3",
  stroke: "color(display-p3 0.6375 0.6375 0.6375)",
  strokeOpacity: 1
}, strokeLinecap: "round" }));
export default SvgTimeIcon;
